
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n434Child = []
  var n435Child = []
  var n436Child = []
  n436Child = n436Child.concat(text(t('.target')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n436 = h('label', props, n436Child)
  n435Child.push(n436)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n435 = h('div', props, n435Child)
  n434Child.push(n435)
  var n437Child = []
  var n438Child = []
  var n439Child = []
  var n440Child = []
  var n441Child = []
  n441Child = n441Child.concat(text(t('.target_main')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "main"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n441 = h('option', props, n441Child)
  n440Child.push(n441)
  var n442Child = []
  n442Child = n442Child.concat(text(t('.target_shift')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "shift"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n442 = h('option', props, n442Child)
  n440Child.push(n442)
  var n443Child = []
  n443Child = n443Child.concat(text(t('.target_background')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "background"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n443 = h('option', props, n443Child)
  n440Child.push(n443)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "target"},{name:'value', val: shadow.target}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n440 = h('select', props, n440Child)
  n439Child.push(n440)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n439 = h('div', props, n439Child)
  n438Child.push(n439)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n438 = h('div', props, n438Child)
  n437Child.push(n438)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n437 = h('div', props, n437Child)
  n434Child.push(n437)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n434 = h('div', props, n434Child)
  n0Child.push(n434)
  var n444Child = []
  var n445Child = []
  var n446Child = []
  n446Child = n446Child.concat(text(t('.scene_id')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n446 = h('label', props, n446Child)
  n445Child.push(n446)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n445 = h('div', props, n445Child)
  n444Child.push(n445)
  var n447Child = []
  var n448Child = []
  var n449Child = []
  var n450Child = []
  var v451 = this.playbookEditor.scenes
  Object.keys(v451).forEach(function (k452) {
    var scene = v451[k452]
    var n453Child = []
    n453Child = n453Child.concat(text(scene._name || t('.untitled')))
    var props = {attributes: runtime.compileAttrs([{name:'key', val: scene},{name:'value', val: scene.id},{name:'selected', val: (shadow.sceneId == scene.id)}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n453 = h('option', props, n453Child)
    n450Child.push(n453)
  }.bind(this))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "sceneId"},{name:'value', val: shadow.sceneId}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n450 = h('select', props, n450Child)
  n449Child.push(n450)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n449 = h('div', props, n449Child)
  n448Child.push(n449)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n448 = h('div', props, n448Child)
  n447Child.push(n448)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n447 = h('div', props, n447Child)
  n444Child.push(n447)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n444 = h('div', props, n444Child)
  n0Child.push(n444)
  var n454Child = []
  var n455Child = []
  var n456Child = []
  n456Child = n456Child.concat(text(t('.transition')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n456 = h('label', props, n456Child)
  n455Child.push(n456)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n455 = h('div', props, n455Child)
  n454Child.push(n455)
  var n457Child = []
  var n458Child = []
  var n459Child = []
  var n460Child = []
  var n461Child = []
  n461Child = n461Child.concat(text(t('.transition_none')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: ""}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n461 = h('option', props, n461Child)
  n460Child.push(n461)
  var n462Child = []
  n462Child = n462Child.concat(text(t('.transition_crossfade')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "crossfade"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n462 = h('option', props, n462Child)
  n460Child.push(n462)
  var n463Child = []
  n463Child = n463Child.concat(text(t('.transition_turn_page')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "turn-page"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n463 = h('option', props, n463Child)
  n460Child.push(n463)
  var n464Child = []
  n464Child = n464Child.concat(text(t('.transition_slide_down')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "slide-down"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n464 = h('option', props, n464Child)
  n460Child.push(n464)
  var n465Child = []
  n465Child = n465Child.concat(text(t('.transition_slide_up')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "slide-up"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n465 = h('option', props, n465Child)
  n460Child.push(n465)
  var n466Child = []
  n466Child = n466Child.concat(text(t('.transition_slide_right')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "slide-right"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n466 = h('option', props, n466Child)
  n460Child.push(n466)
  var n467Child = []
  n467Child = n467Child.concat(text(t('.transition_slide_left')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "slide-left"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n467 = h('option', props, n467Child)
  n460Child.push(n467)
  var n468Child = []
  n468Child = n468Child.concat(text(t('.transition_horizontal_open')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "horizontal-open"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n468 = h('option', props, n468Child)
  n460Child.push(n468)
  var n469Child = []
  n469Child = n469Child.concat(text(t('.transition_horizontal_close')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "horizontal-close"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n469 = h('option', props, n469Child)
  n460Child.push(n469)
  var n470Child = []
  n470Child = n470Child.concat(text(t('.transition_vertical_open')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "vertical-open"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n470 = h('option', props, n470Child)
  n460Child.push(n470)
  var n471Child = []
  n471Child = n471Child.concat(text(t('.transition_vertical_close')))
  var props = {attributes: runtime.compileAttrs([{name:'value', val: "vertical-close"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n471 = h('option', props, n471Child)
  n460Child.push(n471)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "transition"},{name:'value', val: shadow.transition}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n460 = h('select', props, n460Child)
  n459Child.push(n460)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n459 = h('div', props, n459Child)
  n458Child.push(n459)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n458 = h('div', props, n458Child)
  n457Child.push(n458)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n457 = h('div', props, n457Child)
  n454Child.push(n457)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n454 = h('div', props, n454Child)
  n0Child.push(n454)
  var n472Child = []
  var n473Child = []
  var n474Child = []
  n474Child = n474Child.concat(text(t('.transition_duration')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n474 = h('label', props, n474Child)
  n473Child.push(n474)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-label'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n473 = h('div', props, n473Child)
  n472Child.push(n473)
  var n475Child = []
  var n476Child = []
  var n477Child = []
  var n478Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'input'},{name:'name', val: "transitionDuration"},{name:'value', val: shadow.transitionDuration},{name:'type', val: "number"},{name:'step', val: "0.1"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n478 = h('input', props, n478Child)
  n477Child.push(n478)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'control'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n477 = h('div', props, n477Child)
  n476Child.push(n477)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n476 = h('div', props, n476Child)
  n475Child.push(n476)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n475 = h('div', props, n475Child)
  n472Child.push(n475)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'field'},{name:'class', val: 'is-horizontal'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n472 = h('div', props, n472Child)
  n0Child.push(n472)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  